import React from 'react'
import { Coins } from 'lucide-react'
import Loader from '@/components/ui_custom/loader'

export function CreditsStatus({ remainingCredits }: { remainingCredits: number }) {
  const isLoading = !remainingCredits && isNaN(remainingCredits)

  return (
    <div className="flex items-center w-full bg-muted/60 border border-border rounded-xl p-3">
      <div className="flex items-center w-full gap-3">
        <div className="flex items-center justify-center h-9 w-9 rounded-full bg-primary/15 text-coentro shrink-0">
          <Coins className="h-4 w-4" />
        </div>
        <div className="flex flex-col flex-1 min-w-0">
          <span className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
            {remainingCredits === 1 ? 'Crédito restante' : 'Créditos restantes'}
          </span>
          {isLoading ? (
            <Loader variant="spinner" size="sm" color="hsl(var(--primary))" />
          ) : (
            <span className="text-2xl font-bold text-foreground leading-tight tabular-nums">
              {remainingCredits || '0'}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
